import { render, staticRenderFns } from "./atom.tabIcon.vue?vue&type=template&id=17d96b30"
import script from "./atom.tabIcon.vue?vue&type=script&lang=ts"
export * from "./atom.tabIcon.vue?vue&type=script&lang=ts"
import style0 from "./atom.tabIcon.vue?vue&type=style&index=0&id=17d96b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports